import React from 'react'
import { Icon } from 'semantic-ui-react'

import './SortIcon.scss'

const SortIcon = ({ ascending, descending }) => (
  <Icon.Group className="sort-icons">
    <Icon name="sort ascending" className={ascending ? 'active' : ''} />
    <Icon name="sort descending" className={descending ? 'active' : ''} />
  </Icon.Group>
)
SortIcon.defaultProps = {
  ascending: false,
  descending: false,
}
SortIcon.propTypes = {
  ascending: React.PropTypes.bool,
  descending: React.PropTypes.bool,
}

export default SortIcon



// WEBPACK FOOTER //
// ./src/browser/components/SortIcon.js